import { createStore } from 'vuex'

import auth               from './auth'
import users              from './users'
import products           from './products'
import categories         from './categories'
import devices            from './devices'
import labels             from './labels'
import settings           from './settings'
import allergens          from './allergens'
import locations          from './locations'
import menus              from './menus'
import designer           from './designer'
import designerLabels     from './designerLabels'
import canvas             from './canvas'
import fields             from './fields' 
import logos              from './logos'
import tickets            from './tickets'
import fonts              from './fonts'
import productImages      from './productImages'


export default createStore({
  modules: {
    auth,
    users,
    products,
    categories,
    devices,
    labels,
    settings,
    allergens,
    locations,
    menus,
    designer,
    designerLabels,
    canvas,
    fields,
    logos,
    tickets,
    fonts,
    productImages
  }
});